import type { AutoGeneratorForFormModel } from "@/components/features/_model/types/auto-generator-for-form-model";

import type { VoucherForCampaignInputSchema } from "./validation-schema";

const _excludeKeys = ["hotelID", "voucherID", "createdAt", "deletedAt"] as const;
export const excludeKeys = _excludeKeys.map((key) => key);
export type ExcludeKeys = (typeof excludeKeys)[number];

export type MarketingCampaignFormModel = AutoGeneratorForFormModel<
	VoucherForCampaignInputSchema,
	ExcludeKeys,
	QueryData
>;

export type QueryData = {
	hotelEmailAddress: string;
};
